import React from "react"
import styled from "@emotion/styled"

const Articlewrap = styled.article`
    width: 70%;
    margin: 0vh auto;
    background: white;
    position: relative;
    @media (max-width: 599px) {
        width: 90%;
    }
    h1 {
        font-family: 'OpticianSans';
        font-size: 3rem;
        margin-bottom: 10%;
        letter-spacing: 1px;
        position: static;
        border: 0;
        color: black;
        @media (max-width: 599px) {
            line-height: .75em;
            padding-top: 2vh;
            font-size: 2.33rem;
        }
    }
    h2 {
        color: #000;
        background: #fff;
        margin-bottom: 2.5vh;
        font-family: 'OpticianSans';
        font-size: 1.33rem;
        letter-spacing: 1px;    
    }
    
    h3 {
        text-transform: uppercase;
        letter-spacing: 1px;
        font-family: "FaktPro-Bold";
        font-size: .75rem;
    }
    p {
        font-family: "FaktPro-Blond";
        font-size: 1.4rem;
        line-height: 1.5em;
        margin-bottom: 3vh;
        width: 87.5%;
        color: rgba(0,0,0,0.8);
        letter-spacing: .25px;
        @media (max-width: 599px) {
            width: 95%;
            font-size: 1.2rem;
            line-height: 1.4em;
        }
    }
    .small p {
        font-size: 1rem;
    }
    a {
        text-decoration: none;
        color: rgb(0,0,0);
        border-bottom: solid 1px black;
        transition: color 0.3s ease;
        overflow-wrap: break-word;
        &:hover {
            border-bottom: solid 1px red;
            color: red;
        }
    }
    strong {
        font-family: "FaktPro-Bold";
        color: #000;
    }
`

const Article = ({ children }) => {
    return (
        <Articlewrap>
            {children}
        </Articlewrap>
    )
}

export default Article